var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "recommend-resume-dialog",
    attrs: {
      "title": "修改职位",
      "visible": _vm.showDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.showDialog = $event
      }
    }
  }, [_c('el-form', {
    key: _vm.preventKey,
    ref: "ruleForm",
    tag: "component",
    staticClass: "form-beauty",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "选择职位",
      "prop": "positionId"
    }
  }, [_c('transfer-select', {
    attrs: {
      "positionList": _vm.positionList,
      "delivery": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.ruleForm.positionId),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "positionId", $$v)
      },
      expression: "ruleForm.positionId"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showDialog = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm')
      }
    }
  }, [_vm._v("确定")])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-de48f3a2"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/operation/changePositionDialog.vue
// module id = null
// module chunks = 